// extracted by mini-css-extract-plugin
export var work = "work-module--work--S+7iV";
export var workCategories = "work-module--work__categories--Y+N3G";
export var workCategoriesFeatured = "work-module--work__categories--featured--m+AGr";
export var workContent = "work-module--work__content--F+KoR";
export var workContentFeatured = "work-module--work__content--featured--iXcw+";
export var workFeatured = "work-module--work--featured--HwQOS";
export var workImage = "work-module--work__image--N-i0B";
export var workImageFeatured = "work-module--work__image--featured--EWs0W";